import {
  listenForSecurityNotice,
  type EventNameSource,
} from './notifications/security-notice';

/** What starting the signed-in listeners needs, passed in so the application shell stays thin. */
export interface SignedInListenerDeps {
  /** The SSE client, which carries the person's own security notice by event name. */
  source: EventNameSource;
  /** Called with each security notice's payload. */
  onSecurityNotice: (data: unknown) => void;
}

/**
 * Starts what the application shell runs once a person is signed in (app-index
 * afterLoginVerified), and returns the function that stops the security notice listener.
 *
 * The security notice needs no company: the server sends it to the person (#398 C3). Nothing else
 * starts here. The company's people list did until #398 C5, fetched for everyone the moment they
 * signed in; it is now read only by its one consumer, the GDC owner picker, and only for a person
 * who may read the company's roster (D-132 rule 1), so a person who may not is never made to ask
 * for it.
 */
export function startSignedInListeners(deps: SignedInListenerDeps): () => void {
  return listenForSecurityNotice(deps.source, deps.onSecurityNotice);
}
